import Chip from "@/components/Chip";
import SimpleTable from "@/components/SimpleTable";
import { Button } from "@/components/ui/button";
import { AnswerCategory } from "@/schema/console/checking-assessments/AnswerCategory";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface CategoryTableProps {
  data: AnswerCategory[];
}

function CategoryTable({ data }: CategoryTableProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <SimpleTable
      data={data}
      columns={[
        {
          key: "name",
          label: t("assessment-items"),
          render: ({ content, sub_category_count }) => (
            <div className="flex-col">
              <div className="font-medium">{content}</div>
              <div>{sub_category_count} {t("sub-categories")}</div>
            </div>
          ),
        },
        {
          key: "status",
          label: t("status"),
          width: "200px",
          render: ({ is_checked }) => {
            return is_checked ? (
              <Chip label={t("checked")} />
            ) : (
              <Chip variant="info" label={t("not-checked")} />
            );
          },
        },
        {
          key: "action",
          label: "",
          width: "150px",
          render: ({ id, is_checked }) => (
            <Button
              variant="outline"
              onClick={() => navigate(`categories/${id}`)}
            >
              {is_checked ? t("edit") : t("check")}
            </Button>
          ),
        },
      ]}
    />
  );
}

export default CategoryTable;
